export const ACTION_GO_TO_SET_PASSWORD = 'goToSetPassword'

export const systemNotifications = {
  noPassword: {
    id: 'noPassword',
    attributes: {
      readAt: null,
      systemNotification: true,
      data: {
        action: ACTION_GO_TO_SET_PASSWORD,
        actionText: 'c.notifications.system.noPassword.actionText',
        title: 'c.notifications.system.noPassword.title',
        body: 'c.notifications.system.noPassword.body'
      }
    }
  }
}
